var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaretDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.0831 20.833C32.4738 20.4422 32.4738 19.8087 32.0831 19.418C31.6923 19.0272 31.0588 19.0272 30.6681 19.418L24.1256 25.9605L17.5831 19.418C17.3303 19.1652 16.9619 19.0665 16.6166 19.159C16.2713 19.2515 16.0016 19.5212 15.9091 19.8665C15.8166 20.2118 15.9153 20.5802 16.1681 20.833L23.4181 28.083C23.6056 28.2707 23.8602 28.3763 24.1256 28.3763C24.391 28.3763 24.6455 28.2707 24.8331 28.083L32.0831 20.833Z",
    fill: "#9095A2",
    className: "st1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaretDown);
export default __webpack_public_path__ + "static/media/caret-down.681a157174c8ddda25ae8ccd7ad9a7fc.svg";
export { ForwardRef as ReactComponent };